import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Import Swiper styles
import 'swiper/css/pagination'; // Import Pagination styles
import 'swiper/css/navigation';
import client from "../../assets/img/client-3.jpg";

const ClientReview = ({ name, company, reviewTitle, reviewText }) => (
    <div className="item">
        <div className="border single-review-wrap bg-white p-4 m-3">
            <div className="review-body">
                <h5>{reviewTitle}</h5>
                <p>{reviewText}</p>
            </div>
            <div className="review-author d-flex align-items-center">
                <div className="author-avatar">
                    <img src={client} width="64" alt={name} className="rounded-circle shadow-sm img-fluid mr-3" />
                    <span>“</span>
                </div>
                <div className="review-info">
                    <h6 className="mb-0">{name}</h6>
                    <span>{company}</span>
                </div>
            </div>
        </div>
    </div>
);

const ReviewSection = () => {
    return (
        <section className="review-section ptb-100">
            <div className="container">
                {/* Section Heading */}
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-6">
                        <div className="section-heading text-center">
                            <h2>Our Lovely Client Say About Us</h2>
                            <p>Uniquely repurpose strategic core competencies with progressive content. Assertively transition ethical imperatives and collaborative manufactured products.</p>
                        </div>
                    </div>
                </div>

                {/* Client Testimonials */}
                <div className="row">
                    <div className="col-12">
                        <Swiper
                            spaceBetween={30}  // Space between slides
                            slidesPerView={1}  // Number of slides to show at once
                            pagination={{ clickable: true }}  // Add clickable pagination dots
                            loop={true}  // Enable loop (infinite scroll)
                            breakpoints={{
                                640: {
                                    slidesPerView: 1,  // 1 slide for mobile
                                },
                                768: {
                                    slidesPerView: 2,  // 2 slides for tablet
                                },
                                1024: {
                                    slidesPerView: 3,  // 3 slides for desktop
                                },
                            }}
                        >
                            {/* Testimonial 1 */}
                            <SwiperSlide>
                                <ClientReview
                                    name="Ana Joly"
                                    company="BizBite"
                                    reviewTitle="Amazing template"
                                    reviewText="Distinctively foster maintainable metrics whereas multidisciplinary process improvements. Distinctively foster maintainable metrics whereas multidisciplinary process improvements. Objectively implement strategic niches through."
                                />
                            </SwiperSlide>

                            {/* Testimonial 2 */}
                            <SwiperSlide>
                                <ClientReview
                                    name="Tony Roy"
                                    company="BizBite"
                                    reviewTitle="Best template for app"
                                    reviewText="Efficiently innovate customized growth strategies whereas error-free paradigms. Monotonectally enhance stand-alone data with prospective innovation."
                                />
                            </SwiperSlide>

                            {/* Testimonial 3 */}
                            <SwiperSlide>
                                <ClientReview
                                    name="Ana Joly"
                                    company="BizBite"
                                    reviewTitle="Efficiently innovate app"
                                    reviewText="Continually redefine sticky channels whereas extensive 'outside the box' thinking. Rapidiously supply focused schemas vis-a-vis optimal users."
                                />
                            </SwiperSlide>

                            {/* Testimonial 4 */}
                            <SwiperSlide>
                                <ClientReview
                                    name="Ana Joly"
                                    company="BizBite"
                                    reviewTitle="Uniquely mesh flexible"
                                    reviewText="Phosfluorescently optimize intermandated platforms without integrated infrastructures. Proactively redefine granular thinking before."
                                />
                            </SwiperSlide>

                            {/* Testimonial 5 */}
                            <SwiperSlide>
                                <ClientReview
                                    name="Ana Joly"
                                    company="BizBite"
                                    reviewTitle="Amazing template"
                                    reviewText="Distinctively foster maintainable metrics whereas multidisciplinary process improvements. Distinctively foster maintainable metrics whereas multidisciplinary process improvements. Objectively implement strategic niches through."
                                />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReviewSection;
